import { defineComponent, computed } from "vue";
import { u as useRatingProps, a as useRating } from "./hooks/useRating-64b7c876.mjs";
import { u as useVaRatingColorsProps, a as useVaRatingColors } from "./hooks/useVaRatingColors-a49be451.mjs";
import { R as RatingValue } from "./types-7212ca12.mjs";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset-0dfbd395.mjs";
import { _ as _VaRatingItem } from "./components/VaRatingItem/VaRatingItem-add96417.mjs";
import { V as VaRatingItemNumberButton } from "./components/VaRatingItemNumberButton-0f792501.mjs";
import { e as extractComponentProps } from "../../utils/component-options/extract-component-options-6b96d215.mjs";
import { u as useFormFieldProps, a as useFormField } from "../../composables/useFormField-fc3f10c4.mjs";
import { u as useTranslation } from "../../composables/useTranslation-67b81a6e.mjs";
import { f as filterComponentProps } from "../../utils/component-options/filter-props-9727421a.mjs";
const VaRatingItemProps = extractComponentProps(_VaRatingItem);
const VaRatingItemNumberButtonProps = extractComponentProps(VaRatingItemNumberButton, ["modelValue", "itemNumber"]);
const _sfc_main = defineComponent({
  name: "VaRating",
  props: {
    ...useRatingProps,
    ...useVaRatingColorsProps,
    ...useFormFieldProps,
    ...VaRatingItemProps,
    ...VaRatingItemNumberButtonProps,
    ...useComponentPresetProp,
    numbers: { type: Boolean, default: false },
    halves: { type: Boolean, default: false },
    max: { type: Number, default: 5 },
    texts: { type: Array, default: () => [] },
    ariaLabel: { type: String, default: "$t:currentRating" },
    ariaItemLabel: { type: String, default: "$t:voteRating" }
  },
  emits: ["update:modelValue"],
  components: { VaRatingItem: _VaRatingItem, VaRatingItemNumberButton },
  setup(props) {
    const { computedClasses: rootClass } = useFormField("va-rating", props);
    const rating = useRating(props);
    const isInteractionsEnabled = computed(() => !props.disabled && !props.readonly);
    return {
      ...useTranslation(),
      ...useVaRatingColors(props),
      ...rating,
      rootClass,
      VaRatingItemProps: filterComponentProps(VaRatingItemProps),
      VaRatingItemNumberButtonProps: filterComponentProps(VaRatingItemNumberButtonProps),
      isInteractionsEnabled,
      tabIndexComputed: computed(() => isInteractionsEnabled.value ? 0 : void 0),
      onArrowKeyPress: (direction) => {
        const step = props.halves ? RatingValue.HALF : RatingValue.FULL;
        const nextStep = rating.visibleValue.value + step * direction;
        const min = props.clearable ? 0 : step;
        if (nextStep >= min && nextStep <= props.max) {
          rating.onItemValueUpdate(rating.visibleValue.value, step * direction);
        } else if (nextStep < min) {
          rating.onItemValueUpdate(min, 0);
        } else {
          rating.onItemValueUpdate(props.max, direction === -1 ? step * direction : 0);
        }
      }
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaRating.vue_vue_type_script_lang-0e4d2720.mjs.map
